import api from './api';

export interface ArchivedMessage {
  _id: string;
  messageId: string;
  sessionId: string;
  body: string;
  sender: string;
  groupId?: string;
  groupName: string;
  accountName: string;
  isRideRelated: boolean;
  receivedAt: string;
  aiResult?: {
    isRideRequest?: boolean;
    confidence?: number;
    rideId?: string;
  };
}

export interface LiveMessagesResponse {
  messages: ArchivedMessage[];
  pagination: { page: number; limit: number; total: number; pages: number };
}

export const liveMessageService = {
  fetchMessages: async (params: {
    page?: number;
    limit?: number;
    sessionId?: string;
    isRideRelated?: boolean;
  } = {}): Promise<LiveMessagesResponse> => {
    const response = await api.get('/messages/live', { params });
    return response.data;
  },

  deleteMessage: async (id: string): Promise<void> => {
    await api.delete(`/messages/archive/${id}`);
  },

  clearMessages: async (sessionId?: string): Promise<void> => {
    await api.delete('/messages/archive', {
      params: sessionId ? { sessionId } : undefined,
    });
  },
};
